export function toFixedUntilLastNonZero(value: number, maxDecimals = 8): string {
  const str = value.toFixed(maxDecimals)

  if (!str.includes('.')) return str

  const [intPart, fracPart] = str.split('.')

  let lastNonZeroIndex = -1
  for (let i = fracPart.length - 1; i >= 0; i--) {
    if (fracPart[i] !== '0') {
      lastNonZeroIndex = i
      break
    }
  }

  if (lastNonZeroIndex === -1) {
    return intPart
  }

  const trimmedFrac = fracPart.slice(0, lastNonZeroIndex + 1)
  return `${intPart}.${trimmedFrac}`
}
